import type { MobilePlanOffer } from '@backmarket/http-api/src/api-specs-b2c-services/mobile-plan/types/mobile-plan-offers'

export function isBouyguesOffer(offer: MobilePlanOffer) {
  return offer.partner.name === 'BOUYGUES_TELECOM'
}
